export default (value) => value === true
